import './footer.scss'

const Footer = () => {
  return (
    <div className='footer'>
      <span>Accellor Admin</span>
      <span>&copy; Hakeem Dashboard</span>
    </div>
  )
}

export default Footer